import React, { useState, useEffect } from 'react';
import axios from 'axios';
const { API_BASE_URL } = require('./Constants');
const CourseMessages = (props) => {
//   const API_BASE_URL = 'http://your-laravel-app-url';
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
//   const [senderId, setSenderId] = useState('');
  const [loading, setLoading] = useState(false);
  const id = props.id;
  const senderID = props.senderId;
  // Fetch messages from Laravel API
  const fetchMessages = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/messages/${id}`);
      setMessages(res.data);
    //   setSenderId(res.data.sender_id);
    } catch (error) {
      console.error('Error fetching messages:', error);
    }
  };

  // Send new message
  const sendMessage = async (e) => {
    e.preventDefault();
    if (!newMessage.trim()) return;
    
    setLoading(true);
    try {
      await axios.post(`${API_BASE_URL}/api/messages`, {
        message: newMessage,
        enrollment_id: id, // This should come from your app context
        sender_id: senderID,      // This should come from authentication
      });
      
      setNewMessage('');
      fetchMessages(); // Refresh messages after sending
    } catch (error) {
      console.error('Error sending message:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMessages();
    // Set up interval to refresh messages every 10 seconds
    const interval = setInterval(fetchMessages, 10000);
    return () => clearInterval(interval);
  }, []);

  return (

    <div className="min-h-screen bg-base-200 p-6">
      <div className="max-w-4xl mx-auto bg-base-100 rounded-xl shadow-lg overflow-hidden">
        <div className="p-6">
          <h1 className="text-3xl font-bold text-center mb-6">Course Messages</h1>
          {/* Message Input Form */}
          <form onSubmit={sendMessage} className="flex gap-2">
            <input
              type="text"
              placeholder="Type your message here..."
              className="input input-bordered flex-grow"
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              disabled={loading}
            />
            <button 
              type="submit" 
              className={`btn btn-primary ${loading ? 'loading' : ''}`}
              disabled={!newMessage.trim() || loading}
            >
              Send
            </button>
          </form>
          {/* Messages Display */}
          <div className="bg-base-200 rounded-lg p-4 mb-6 h-96 overflow-y-auto">
            {messages.length === 0 ? (
              <div className="flex items-center justify-center h-full">
                <p className="text-gray-500">No messages yet. Start a conversation!</p>
              </div>
            ) : (
              <div className="space-y-4">
                {messages.map(message => (
                  <div 
                    key={message.id} 
                    className={`chat ${message.sender_id === 1 ? 'chat-end' : 'chat-start'}`}
                  >
                    <div className="chat-image avatar">
                      <div className="w-10 rounded-full bg-primary text-primary-content flex items-center justify-center">
                        {message.sender_name ? message.sender_name.charAt(0).toUpperCase() : 'U'}
                      </div>
                    </div>
                    <div className="chat-header mb-1">
                      {message.sender.name || 'Unknown User'}
                      <time className="text-xs opacity-50 ml-2">
                        {new Date(message.created_at).toLocaleTimeString()}
                      </time>
                    </div>
                    <div className={`chat-bubble ${message.sender_id === 1 ? 'chat-bubble-primary' : ''}`}>
                      {message.message}
                    </div>
                    <div className="chat-footer opacity-50 text-xs mt-1">
                      {new Date(message.created_at).toLocaleDateString()}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
          
          
        </div>
      </div>
    </div>
  );
};

export default CourseMessages;